// Tuned so a 1080×1920 at 30fps lands on ~8 Mbps, which is what we had settled on by hand.
const BITS_PER_PIXEL = 0.13;
const MIN_BITRATE = 2_000_000;
const MAX_BITRATE = 20_000_000;

export const videoBitrateFor = (width: number, height: number, fps: number): number =>
  Math.round(Math.min(MAX_BITRATE, Math.max(MIN_BITRATE, width * height * fps * BITS_PER_PIXEL)));
